import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
  TextField,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

interface PostClosingDateModalProps {
  title: string;
  fieldKey: string;
  loans: any[];
  onConfirm: (value: string) => void;
  onClose: () => void;
}

export const PostClosingDateModal: React.FC<PostClosingDateModalProps> = ({
  title,
  loans,
  onConfirm,
  onClose,
}) => {
  const [value, setValue] = useState<string>('');

  const handleConfirm = () => {
    if (value) onConfirm(value);
  };

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle disableTypography style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">{title}</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box mb={3}>
          <Typography variant="subtitle1">Select Date:</Typography>
          <TextField
            type="date"
            fullWidth
            value={value}
            onChange={e => setValue(e.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{ 'aria-label': 'date input' }}
          />
        </Box>

        <Box>
          <Typography variant="subtitle1">Loans to update:</Typography>
          <List dense>
            {loans.map((loan, index) => (
              <ListItem key={index} divider>
                <ListItemText primary={`Loan ID: ${loan}`} />
              </ListItem>
            ))}
          </List>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="default">
          Cancel
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained" disabled={!value}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};